import { render, staticRenderFns } from "./CustomerEditTabAccount.vue?vue&type=template&id=3e9bfc6e&"
import script from "./CustomerEditTabAccount.vue?vue&type=script&lang=js&"
export * from "./CustomerEditTabAccount.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports